import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import config from 'garaje/config/environment';

export default class ScreensRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (this.abilities.cannot('visit global-screens')) {
      return void this.router.transitionTo('unauthorized');
    }

    if (config.environment === 'test') {
      return;
    }

    const { cookieDomain } = config;
    const domain = cookieDomain.includes('christmas') ? `apps.${cookieDomain}` : cookieDomain;

    const PRELOAD_APPS = ['screens-command-home'];

    PRELOAD_APPS.map((app) => {
      void import(/* webpackIgnore: true */ `https://sapi.${domain}/s/${app}`);
    });
  }
}
